"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function listRandom(array) {
    if (!array)
        return 1;
    return Math.floor(array.length * Math.random());
}
exports.default = listRandom;
